export class UserReset1Model {
	email?: string;
	emailError?: any;

	constructor(data: any = {}) {
		this.email = data.email || "";
	}
}
